import React, { Component } from 'react';
import { connect } from 'react-redux';

import SearchAssociatesUrls from '../tools/search-associates-urls';

const SearchAssosiatesSyncCookiePageUrl = SearchAssociatesUrls.syncCookiePage();

class SharedTokenSyncPage extends Component {
  constructor(props) {
    super(props);

    this.handleLoad = this.handleLoad.bind(this);
  }

  postMessageToSearchAssosiatesSyncCookiePage(message) {
    window.frames.searchAssosiatesSyncCookiePage.postMessage(
      message,
      SearchAssosiatesSyncCookiePageUrl
    );
  }

  handleLoad() {
    const { authUser } = this.props;

    if (authUser.get('sharedAuthToken')) {
      this.postMessageToSearchAssosiatesSyncCookiePage(
        authUser.get('sharedAuthToken')
      );
    }
  }

  componentWillReceiveProps({ authUser }) {
    if (
      this.props.authUser.get('sharedAuthToken') !==
      authUser.get('sharedAuthToken')
    ) {
      this.postMessageToSearchAssosiatesSyncCookiePage(
        authUser.get('sharedAuthToken')
      );
    }
  }

  render() {
    return (
      <iframe
        title="searchAssosiatesSyncCookieFrame"
        src={SearchAssosiatesSyncCookiePageUrl}
        name="searchAssosiatesSyncCookiePage"
        style={{ display: 'none' }}
        onLoad={this.handleLoad}
      />
    );
  }
}

export default connect(state => ({
  authUser: state.authUser
}))(SharedTokenSyncPage);



// WEBPACK FOOTER //
// ./src/containers/shared-token-sync-page.js